import useSharedRecord from "../hooks/useSharedRecord";
import { useDebouncedValue } from "../hooks/useDebouncedValue";
import PageHeading from "../components/PageHeading";
import SearchPending from "../components/SearchPending";
import { apiErrorMessage } from "../utils/apiError";
import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import axios from "../axios/AxiosInstance";
import { Users, Plus, Search, Phone, Mail, CheckCircle2, Clock } from "lucide-react";
import ClientDetail from "./ClientDetail";
import CreateClientModal from "./clients/CreateClientModal";
import { createClientSearch } from "../utils/clientSearch";

// import { ClientModel } from 'types'; // Type import commented out as per user request

export default function ClientsPage({ mode = "clients" }) {
  const [recordsReady, setRecordsReady] = useState(false);
  const [clients, setClients] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [loadError, setLoadError] = useState("");
    const [originalClients, setOriginalClients] = useState([]);
  const [isOpenModal, setIsOpenModal] = useState(false);
    const [selectedClient, setSelectedClient] = useState(null);
  const {select: selectSharedClient, missing: missingSharedClient} = useSharedRecord(originalClients, recordsReady, setSelectedClient);
  const [searchCriterion, setSearchCriterion] = useState("all");
  const [searchTerm, setSearchTerm] = useState("");
  const [appliedSearch, searching] = useDebouncedValue(searchTerm);
  
  //company
                    
  //ADRESSES

      
      
  //contact
        
  //facturation

  
  
        
  const paymentConditions = [
    "À Réception",
    "À 10 jours",
    "À 15 jours",
    "Fin de mois",
    "30 jours date de facture",
    "30 jours fdm",
    "30 jours fdm le 5",
    "30 jours fdm le 10",
    "30 jours fdm le 15",
    "30 jours fdm le 20",
    "30 jours fdm le 25",
    "À 45 jours",
    "À 45 jours fdm",
    "60 jours date de facture",
    "60 jours fdm",
    "60 jours fdm le 5",
    "60 jours fdm le 10",
    "60 jours fdm le 15",
    "60 jours fdm le 20",
    "60 jours fdm le 25",
  ];

  const TVA = [
    "TVA 20%",
    "TVA 10%",
    "TVA 8.5%",
    "TVA 5.5%",
    "TVA 2.1%",
    "TVA 0% UE",
    "TVA 0% HORS UE",
  ];

  TVA.map((tva) => {
    return {
      value: tva,
      label: tva,
    };
  });

  paymentConditions.map((paymentCondition) => {
    return {
      value: paymentCondition,
      label: paymentCondition,
    };
  });

  
  
  
  
  
  
  
  
  
      
  
  useEffect(() => {
    const controller = new AbortController();
    setIsLoading(true);
    setLoadError("");
    axios
      .get("client/freelance", { signal: controller.signal })
      .then((res) => {
        setClients(res.data);
        setOriginalClients(res.data);
        setRecordsReady(true);
      })
      .catch((error) => {
        const detail = apiErrorMessage(error, "Impossible de charger les clients.");
        if (detail) setLoadError(detail);
      })
      .finally(() => {
        if (!controller.signal.aborted) setIsLoading(false);
      });
    return () => controller.abort();
  }, []);

  const filteredClients = originalClients.filter(createClientSearch(appliedSearch, searchCriterion));

  const hasPld = (client) => client.pld != null && String(client.pld).trim() !== "";
  const stats = {
    total: originalClients.length,
    clients: originalClients.filter(hasPld).length,
    prospects: originalClients.filter((client) => !hasPld(client)).length,
  };

  const updateClients = (updatedClients) => {
    setClients(updatedClients);
    setOriginalClients((current) => {
      const merged = new Map(current.map((client) => [client._id, client]));
      updatedClients.forEach((client) => merged.set(client._id, client));
      return Array.from(merged.values());
    });
  };


  return (
    <div className="">
      <div className="">
        {/* Header Section */}
        <motion.div
          className="rounded-2xl mb-6"
        >
          <div className="flex flex-col md:flex-row md:items-center md:justify-between">
            <div className="mb-4 md:mb-0">
              <div className="flex items-center space-x-3 mb-2">
                <div><PageHeading icon="clients" title={mode === "atradius" ? "Atradius" : mode === "devis" ? "Devis" : "Mes clients"} description={mode === "atradius" ? "Sélectionnez un client pour consulter sa couverture ou demander une cote Atradius." : mode === "devis" ? "Sélectionnez un client pour consulter ou créer ses devis." : "Gérez votre portefeuille client et prospects"} />
                </div>
              </div>
            </div>
            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              onClick={() => setIsOpenModal(true)}
              className="bg-blue-600 text-white px-6 py-3 rounded-xl font-semibold shadow-lg hover:shadow-xl hover:bg-blue-700 transition-all duration-200 flex items-center space-x-2"
            >
              <Plus className="w-5 h-5" />
              <span>Nouveau client</span>
            </motion.button>
          </div>
        </motion.div>

        {/* Statistics Cards */}
        <motion.div
          className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8"
        >
          <motion.div
            whileHover={{ y: -2 }}
            className="bg-white rounded-xl shadow-sm border border-slate-200 p-6 hover:shadow-md transition-all duration-200"
          >
            <div className="flex items-center justify-between">
              <div>
                <p className="text-slate-600 text-sm font-medium">Total entreprises</p>
                <p className="text-3xl font-bold text-slate-900 mt-1">{stats.total}</p>
              </div>
              <div className="bg-blue-100 p-3 rounded-lg">
                <Users className="w-6 h-6 text-blue-600" />
              </div>
            </div>
          </motion.div>

          <motion.div
            whileHover={{ y: -2 }}
            className="bg-white rounded-xl shadow-sm border border-slate-200 p-6 hover:shadow-md transition-all duration-200"
          >
            <div className="flex items-center justify-between">
              <div>
                <p className="text-slate-600 text-sm font-medium">Clients</p>
                <p className="text-3xl font-bold text-green-600 mt-1">{stats.clients}</p>
              </div>
              <div className="bg-green-100 p-3 rounded-lg">
                <CheckCircle2 className="w-6 h-6 text-green-600" />
              </div>
            </div>
          </motion.div>

          <motion.div
            whileHover={{ y: -2 }}
            className="bg-white rounded-xl shadow-sm border border-slate-200 p-6 hover:shadow-md transition-all duration-200"
          >
            <div className="flex items-center justify-between">
              <div>
                <p className="text-slate-600 text-sm font-medium">Prospects</p>
                <p className="text-3xl font-bold text-orange-500 mt-1">{stats.prospects}</p>
              </div>
              <div className="bg-orange-100 p-3 rounded-lg">
                <Clock className="w-6 h-6 text-orange-500" />
              </div>
            </div>
          </motion.div>

        </motion.div>
        {/* Search and Filters */}
        <motion.div
          className="bg-white rounded-xl shadow-sm border border-slate-200 p-6 mb-8"
        >
          <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-6">
            <div>
              <label htmlFor="client-search-criterion" className="sr-only">Critère de recherche</label>
              <select id="client-search-criterion" value={searchCriterion} onChange={(e) => setSearchCriterion(e.target.value)} className="rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm text-slate-700 focus:outline-none focus:ring-2 focus:ring-blue-500">
                <option value="all">Tous les critères</option>
                <option value="company">Nom de l’entreprise</option>
                <option value="contact">Contact</option>
                <option value="phone">Téléphone</option>
                <option value="email">Email</option>
                <option value="address">Adresse, ville, code postal</option>
                <option value="reference">SIRET ou PLD</option>
              </select>
            </div>
            {/* Search */}
            <div className="flex-1 max-w-md">
              <div className="relative">
                <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-slate-400 w-4 h-4" />
                <input
                  type="text"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  placeholder="Nom, contact, téléphone, adresse…"
                  aria-label="Rechercher dans les clients et prospects"
                  className="pl-10 pr-4 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 w-full"
                />
              </div>
              <SearchPending pending={searching} />
            </div>


          </div>
        </motion.div>

        {loadError && <p role="alert" className="mb-4 rounded-xl bg-rose-50 p-4 text-sm text-rose-700">{loadError}</p>}
        {/* Liste des clients */}
        <motion.div
        >
          {isLoading ? (
            <div className="flex justify-center items-center h-64">
              <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
            </div>
          ) : filteredClients.length === 0 ? (
            <div className="text-center py-12">
              <Users className="w-16 h-16 text-slate-300 mx-auto mb-4" />
              <h3 className="text-lg font-medium text-slate-900 mb-2">Aucun client trouvé</h3>
              <p className="text-slate-500">
                {searchTerm ? "Essayez de modifier vos critères de recherche" : "Commencez par créer votre premier client"}
              </p>
            </div>
          ) : (
            <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden">
              <div className="overflow-x-auto">
                <table className="min-w-full divide-y divide-slate-200">
                  <thead className="bg-slate-50">
                    <tr>
                      <th className="px-4 py-4 text-left text-xs font-medium text-slate-500 uppercase tracking-wider">
                        Client
                      </th>
                      <th className="px-4 py-4 text-left text-xs font-medium text-slate-500 uppercase tracking-wider">
                        Contact
                      </th>
                      <th className="px-4 py-4 text-left text-xs font-medium text-slate-500 uppercase tracking-wider">
                        Coordonnées
                      </th>
                      <th className="px-4 py-4 text-left text-xs font-medium text-slate-500 uppercase tracking-wider">
                        Adresse
                      </th>

                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-slate-200">
                    {missingSharedClient && <tr><td colSpan={4}><p role="alert" className="rounded-lg bg-amber-50 p-3 text-sm text-amber-800">Cette fiche client est introuvable ou inaccessible dans votre agence.</p></td></tr>}
      <AnimatePresence>
                      {filteredClients.map((client, index) => {
                        const contact = Array.isArray(client.contacts) ? client.contacts[0] : null;
                        const contactName = [client.contactFirstname, client.contactLastname].filter(Boolean).join(" ") || [contact?.firstname, contact?.lastname].filter(Boolean).join(" ");
                        const phone = client.contactPhone || contact?.mobile || contact?.phone;
                        const email = client.contactEMail || contact?.email;
                        return (
                        <motion.tr
                          key={client._id || index}
                          className="hover:bg-slate-50 transition-colors duration-200 cursor-pointer"
                          onClick={() => selectSharedClient(client)}
                          tabIndex={0}
                          aria-label={`Ouvrir la fiche de ${client.companyName}`}
                          onKeyDown={event => {
                            if (event.target === event.currentTarget && ["Enter", " "].includes(event.key)) {
                              event.preventDefault();
                              selectSharedClient(client);
                            }
                          }}
                        >
                          <td className="px-4 py-4 whitespace-nowrap">
                            <div>
                                <div className="flex items-center gap-2 text-sm font-medium text-slate-900">
                                  <span>{client.companyName}</span>
                                  <span className={`inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium ${hasPld(client) ? "bg-green-100 text-green-800" : "bg-orange-100 text-orange-800"}`}>
                                    {hasPld(client) ? "Client" : "Prospect"}
                                  </span>
                                </div>
                                <div className="text-sm text-slate-500">
                                  {client.siret ? `SIRET : ${client.siret}` : "SIRET non renseigné"}
                                  {hasPld(client) && <span className="mt-1 block text-xs font-medium text-blue-700">PLD : {client.pld}</span>}
                                </div>
                            </div>
                          </td>
                          <td className="px-4 py-4 whitespace-nowrap">
                            <div className="text-sm text-slate-900">{contactName || "—"}</div>
                            {contact?.profession && <div className="mt-1 text-xs text-slate-500">{contact.profession}</div>}
                          </td>
                          <td className="px-4 py-4">
                            <div className="space-y-2 text-sm">
                              {phone ? <a href={`tel:${String(phone).replace(/[^+0-9]/g, "")}`} onClick={(event) => event.stopPropagation()} className="inline-flex items-center gap-2 whitespace-nowrap font-medium text-slate-800 hover:text-blue-700 hover:underline"><Phone size={14} className="shrink-0 text-slate-400" aria-hidden="true" />{phone}</a> : <p className="text-xs text-slate-400">Téléphone non renseigné</p>}
                              {email ? <a href={`mailto:${email}`} onClick={(event) => event.stopPropagation()} className="flex items-center gap-2 text-blue-700 hover:underline"><Mail size={14} className="shrink-0 text-slate-400" aria-hidden="true" /><span className="break-all">{email}</span></a> : <p className="text-xs text-slate-400">Email non renseigné</p>}
                            </div>
                          </td>
                          <td className="px-4 py-4">
                            <div className="min-w-32 text-sm text-slate-900">{[client.postCode, client.town].filter(Boolean).join(" ") || "—"}</div>
                            <div className="mt-1 text-xs text-slate-500">{client.address || ""}</div>
                          </td>

                        </motion.tr>
                      );
                      })}
                    </AnimatePresence>
                  </tbody>
                </table>
              </div>
            </div>
          )}
        </motion.div>

        {/* Client Detail Modal */}
        {selectedClient && (
          <ClientDetail
            key={selectedClient?._id}
            initialSection={mode === "atradius" ? "financial" : mode === "devis" ? "devis" : "info"}
            client={selectedClient}
            originalClients={originalClients}
            setClient={selectSharedClient}
            clients={clients}
            setClients={updateClients}
          />
        )}

        {/* Create Client Modal */}
        {isOpenModal && (
          <CreateClientModal
            clients={clients}
            setClients={updateClients}
            open={isOpenModal}
            onOpenChange={() => setIsOpenModal(false)}
          />
        )}
      </div>
    </div>
  );
}
